const CHANNEL_NAME = 'embrace-session'

interface SessionMessage {
  type: 'logout'
  timestamp: number
}

export function useSessionChannel() {
  let channel: BroadcastChannel | null = null

  if (typeof BroadcastChannel !== 'undefined') {
    try {
      channel = new BroadcastChannel(CHANNEL_NAME)
    } catch {
      // BroadcastChannel not available (e.g., some older browsers)
    }
  }

  const notifyLogout = () => {
    if (!channel) return

    const message: SessionMessage = {
      type: 'logout',
      timestamp: Date.now()
    }

    try {
      channel.postMessage(message)
    } catch {
      // Channel may have been closed
    }
  }

  const onLogout = (callback: (message: SessionMessage) => void) => {
    if (!channel) return

    channel.onmessage = (event: MessageEvent<SessionMessage>) => {
      if (event.data?.type === 'logout') {
        callback(event.data)
      }
    }
  }

  const destroy = () => {
    if (!channel) return

    try {
      channel.close()
    } catch {
      // Already closed
    }
    channel = null
  }

  return { notifyLogout, onLogout, destroy }
}
